import { render, staticRenderFns } from "./FallPage.vue?vue&type=template&id=0abb4bec&scoped=true&"
import script from "./FallPage.vue?vue&type=script&lang=js&"
export * from "./FallPage.vue?vue&type=script&lang=js&"
import style0 from "./FallPage.vue?vue&type=style&index=0&id=0abb4bec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb4bec",
  null
  
)

export default component.exports